<template>
    <div class="contacts-dashboard">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Contatos</mu-title>

        <!-- Lista das opções de menu -->
        <mu-options :options="options"></mu-options>

    </div>
</template>

<script>
    import Menu from '@/config/menu'

    // Chamamos o menu de contacts
    let MenuOptions = Menu.find('contacts')

    export default {
        name: 'app-contacts-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: MenuOptions
            }
        }
    }
</script>
